import * as React from "react";
import {
  FolderPlus,
  LifeBuoy,
  Send,
  BookOpen,
  Sparkles,
  GitGraph,
  Home,
  Users,
  UserCheck,
  GraduationCap,
  Bot,
} from "lucide-react";
import { NavGrouped } from "./nav-grouped";
// import { NavProjects } from './nav-projects';
import { NavPrimary } from "./nav-primary";
import { NavUser } from "./nav-user";
import { TeamSwitcher } from "./team-switcher";
import { NavConversations } from "./nav-conversations";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";
import VERSIONS from "@/assets/js/versions";
import { useTranslation } from "react-i18next";

const APP_VERSION = VERSIONS[process.env.REACT_APP_VERSION];

const isBrogrammers = APP_VERSION.brand === "Brogrammers";
// const isZenshkool = APP_VERSION.brand === 'Zenshkool';
// const isEdunexora = APP_VERSION.brand === 'Edunexora';

export function AppSidebar({ selectedRole, setSelectedRole, ...props }) {
  const { t } = useTranslation();
  const isZenshkool = APP_VERSION.brand === "Zenshkool";

  // Define role-specific navigation data
  const getRoleData = (role) => {
    if (!isZenshkool) {
      role = "student" || "member";
    }

    switch (role) {
      case "teacher":
        return {
          navPrimary: [
            {
              title: t("sidebar.dashboard"),
              url: "/teacher/dashboard",
              icon: Home,
            },
            {
              title: t("sidebar.myClasses"),
              url: "/teacher/classes",
              icon: Users,
            },
            {
              title: t("sidebar.aiInsights"),
              url: "/teacher/ai_insights",
              icon: Bot,
            },
          ],
          navGrouped: [],
          navSecondary: [
            { title: t("sidebar.support"), url: "/help", icon: LifeBuoy },
            { title: t("sidebar.feedback"), url: "/feedback", icon: Send },
          ],
        };

      case "admin":
        return {
          navPrimary: [
            {
              title: t("sidebar.dashboard"),
              url: "/admin/dashboard",
              icon: Home,
            },
            { title: t("sidebar.classes"), url: "/admin/classes", icon: Users },
            {
              title: t("sidebar.students"),
              url: "/admin/students",
              icon: GraduationCap,
            },
            { title: t("sidebar.staff"), url: "/admin/staff", icon: UserCheck },
            // { title: t('sidebar.aiUsage'), url: '/admin/ai-usage', icon: Bot },
            // { title: t('sidebar.account'), url: '/admin/account', icon: Settings },
          ],
          navGrouped: [],
          navSecondary: [
            { title: t("sidebar.support"), url: "/help", icon: LifeBuoy },
            { title: t("sidebar.feedback"), url: "/feedback", icon: Send },
          ],
        };

      default:
        return {
          navPrimary: [
            { title: t("sidebar.home"), url: "/student/home", icon: Home },
            {
              title: t("sidebar.courses"),
              url: "/student/courses",
              icon: BookOpen,
            },
            {
              title: t("sidebar.create"),
              url: "/student/create",
              icon: FolderPlus,
            },
          ],
          navGrouped: [
            {
              title: t("sidebar.learning"),
              url: "#",
              icon: GraduationCap,
              isVisible: false,
              items: [
                { title: t("sidebar.explore"), url: "/student/explore" },
                { title: t("sidebar.progress"), url: "/student/progress" },
                {
                  title: t("sidebar.achievements"),
                  url: "/student/achievements",
                },
              ],
            },
            {
              title: t("sidebar.dataStructures"),
              url: "#",
              icon: GitGraph,
              isVisible: isBrogrammers,
              items: [
                { title: "75 Blind", url: "/student/dsa-sheet" },
                { title: t("sidebar.dsaSheet"), url: "/student/dsa-graph" },
              ],
            },
          ],
          navSecondary: [
            { title: t("sidebar.support"), url: "/help", icon: LifeBuoy },
            { title: t("sidebar.feedback"), url: "/feedback", icon: Send },
            {
              title: t("sidebar.getUnlimitedAI"),
              url: "/subscription",
              icon: Sparkles,
            },
          ],
        };
    }
  };

  const data = getRoleData(selectedRole);

  // For non-Zenshkool brands, force student role for navigation
  const effectiveRole = isZenshkool ? selectedRole : "student";

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher
          selectedRole={effectiveRole}
          setSelectedRole={isZenshkool ? setSelectedRole : undefined}
        />
      </SidebarHeader>
      <SidebarContent>
        <NavPrimary items={data?.navPrimary} />
        <NavGrouped items={data?.navGrouped} />
        {effectiveRole === "student" && <NavConversations />}
        {/* <NavProjects projects={data.projects} /> */}
        <NavPrimary items={data?.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
